import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allGetTrends, clearTrendsState, trendsParams } from "@/state/trendsSlice";
import { TrendsRow } from "@/components/trends";
import { trailerTypes } from "@/utils/constants";

export const Trends = () => {
    const dispatch = useDispatch();
    const trendsData = useSelector((state) => state.trends);

    useEffect(() => {
        allGetTrends.forEach((get) => {
            dispatch(get.thunk());
        });
        return () => {
            dispatch(clearTrendsState());
        };
    }, []);

    return (
        <div className="text-cm-text flex flex-col items-center justify-start md:justify-center w-full grow min-h-full">
            <div className="mx-4 lg:mx-0 flex flex-col gap-6 w-full lg:w-auto">
                <TrendsRow
                    trailerType={trailerTypes[0].text}
                    numOfDays={trendsParams[0].days}
                    trends={trendsData[`${trendsParams[0].trailerType}_${trendsParams[0].days}`]}
                />
                <TrendsRow
                    trailerType={trailerTypes[0].text}
                    numOfDays={trendsParams[1].days}
                    trends={trendsData[`${trendsParams[1].trailerType}_${trendsParams[1].days}`]}
                />
                <TrendsRow
                    trailerType={trailerTypes[1].text}
                    numOfDays={trendsParams[2].days}
                    trends={trendsData[`${trendsParams[2].trailerType}_${trendsParams[2].days}`]}
                />
                <TrendsRow
                    trailerType={trailerTypes[1].text}
                    numOfDays={trendsParams[3].days}
                    trends={trendsData[`${trendsParams[3].trailerType}_${trendsParams[3].days}`]}
                />
                <TrendsRow
                    trailerType={trailerTypes[2].text}
                    numOfDays={trendsParams[4].days}
                    trends={trendsData[`${trendsParams[4].trailerType}_${trendsParams[4].days}`]}
                />
                <TrendsRow
                    trailerType={trailerTypes[2].text}
                    numOfDays={trendsParams[5].days}
                    trends={trendsData[`${trendsParams[5].trailerType}_${trendsParams[5].days}`]}
                />
            </div>
        </div>
    );
};
